import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { Logo, DropdownMenu, HeaderProductSearch } from "../../components";

type THeaderProps = {
  onBurgerClick?: () => void;
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  boxShadow: "0px 2px 10px 0px #9D999940",
  borderBottom: `0.5px solid ${theme.palette.divider}`,
  height: "70px",
  justifyContent: "center",
}));

export const Header = ({ onBurgerClick }: THeaderProps) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <StyledAppBar position="fixed" elevation={0}>
      <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
        <Box display="flex" alignItems="center">
          <IconButton
            size="small"
            onClick={onBurgerClick}
            color="inherit"
            sx={{
              mr: 2,
              [theme.breakpoints.up("md")]: {
                display: "none",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Logo height={23} />
        </Box>
        <Box
          display={{ xs: "none", md: "flex" }}
          flex={1}
          maxWidth={730}
          mx={4}
        >
          <HeaderProductSearch />
        </Box>
        {!isXs && <DropdownMenu />}
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
